/**
 * The app's QueryClient defaults, shared by `main.tsx` and the tests that
 * must see production behaviour (a query's own options override these).
 */

import { QueryClient, type DefaultOptions } from '@tanstack/react-query';

export const QUERY_CLIENT_DEFAULTS: DefaultOptions = {
  queries: {
    staleTime: 1000 * 60, // 1 minute
    retry: 1,
  },
};

export function createQueryClient(): QueryClient {
  return new QueryClient({ defaultOptions: QUERY_CLIENT_DEFAULTS });
}
